import { createFileRoute } from '@tanstack/react-router';

import Page from '@/screens/chat/staging-inbox/page';

export const Route = createFileRoute('/_app/_chat/staging-inbox/')({
  component: Page,
});
